import RiskStatusIcon from "@/views/Risk/shared/RiskStatusIcon";
import type { SignalTableRow } from "./utils";

type SignalStatusIconProps = {
  value: SignalTableRow[string];
};

export default function SignalStatusIcon({ value }: SignalStatusIconProps) {
  if (value === "Red") {
    return <RiskStatusIcon tone="red" />;
  }

  if (value === "Yellow") {
    return <RiskStatusIcon tone="yellow" />;
  }

  if (value === "Green") {
    return <RiskStatusIcon tone="green" />;
  }

  return <RiskStatusIcon tone="default" />;
}
